import httpClient, {objectToUrlParams} from "./_httpClient";

const END_POINT = "/invoices";

const uploadExcel = (scopeId, excelFile, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", excelFile);
  if (scopeId) {
      formData.append("scopeId", scopeId);
  }
  return httpClient.post(
    END_POINT + "/import",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
};
const getInvoice = (invoiceId) => httpClient.get(END_POINT + "/" +invoiceId);
const addInvoice = (invoiceData) => httpClient.post(END_POINT, invoiceData);
const editInvoice = (id,invoiceData) => httpClient.put(END_POINT + '/' + id, invoiceData);
const deleteInvoice = (ids) => httpClient.post(END_POINT + '/deleteInvoices',{ids});
const deleteInvoicePayment = (id) => httpClient.delete(END_POINT + '/payments/' + id);

const exportInvoicesByScope = (scopeId,config, params) => httpClient.get(END_POINT + "/export/" + scopeId+objectToUrlParams(params), config);
const getPreImportRapport = (scopeId, attachment, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", attachment);

  if (scopeId) {
    formData.append("scopeId", scopeId);
  }

  return httpClient.post(
    END_POINT + "/rapport",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
}

const getProcessedInvoicesPreImportRapport = (scopeId, attachment, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", attachment);

  if (scopeId) {
    formData.append("scopeId", scopeId);
  }

  return httpClient.post(
    END_POINT + "/processed-invoices/rapport",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
}

const uploadProcessedInvoices = (scopeId, excelFile, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", excelFile);
  if (scopeId) {
      formData.append("scopeId", scopeId);
  }
  return httpClient.post(
    END_POINT + "/import-processed-invoices",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
};

const dispatchImportInvoicesJob = (activity_log_id) => httpClient.post(END_POINT + '/dispatchImportInvoicesJob/' + activity_log_id);

export {
  uploadExcel,
  getInvoice,
  addInvoice,
  editInvoice,
  deleteInvoice,
  exportInvoicesByScope,
  getPreImportRapport,
  deleteInvoicePayment,
  getProcessedInvoicesPreImportRapport,
  uploadProcessedInvoices,
  dispatchImportInvoicesJob
}
